export const languages = [
    { code: 'es_ES', name: 'LANGUAGES.es_ES' },
    { code: 'en_UK', name: 'LANGUAGES.en_UK' },
    { code: 'fr_FR', name: 'LANGUAGES.fr_FR' },
    { code: 'pt_PT', name: 'LANGUAGES.pt_PT' },
    //{ code: 'gr_GR', name: 'LANGUAGES.gr_GR' },
    { code: 'nl_NL', name: 'LANGUAGES.nl_NL' }
];